export const INCREASE = 'INCREASE'
export const DECREASE = 'DECREASE'
export const DROP_SHOW_HIDE = 'DROP_SHOW_HIDE'
export const SIDE_MENU_SHOW_HIDE = 'SIDE_MENU_SHOW_HIDE'
export const DROP_MENU_SHOW_HIDE = 'DROP_MENU_SHOW_HIDE'
export const DARK_THEME = 'DARK_THEME'
